import { create } from 'zustand';

type Snackbar = {
  id: string;
  message: string;
  severity: 'success' | 'error' | 'warning' | 'info';
  duration?: number;
  // Centers the snackbar stack over the action bar instead of the viewport
  anchorToActionBar?: boolean;
};

type SnackbarStateStore = {
  snackBars: Snackbar[];
  showSnackbar: (snackbar: Omit<Snackbar, 'id'>) => void;
  closeSnackbar: (id: string) => void;
};

export const useSnackbarStore = create<SnackbarStateStore>((set) => ({
  snackBars: [],
  showSnackbar: (snackbar) =>
    set((state) => ({
      snackBars: [...state.snackBars, { ...snackbar, id: crypto.randomUUID() }],
    })),
  closeSnackbar: (id) =>
    set((state) => ({
      snackBars: state.snackBars.filter((snackbar) => snackbar.id !== id),
    })),
}));

/**
 * This hook provides a similar API to Chakra's useToast, making use of MUI's Snackbar component.
 * @example
 * const showSnackbar = useSnackbar();
 * showSnackbar({ message: 'This is an error message', severity: 'error' });
 * showSnackbar({ message: 'This is a success message', severity: 'success', duration: 3000 });
 */
export function useSnackbar() {
  return useSnackbarStore((s) => s.showSnackbar);
}
